import Settings from "../../../model/settings/Settings";
import {Action} from "redux-actions";
import {SETTINGS_FETCHED} from "./actionType";
import {OnFailure, OnSuccess, OnSuccessData} from "../actionHelpers";
import {Dispatch} from "redux";
import {api} from "../../../api/api";

/**
 * Settings fetched successful action.
 * @param {Settings} settings installer portal settings.
 * @return {Action<SETTINGS_FETCHED>}
 */
function settingsFetched(settings: Settings): Action<SETTINGS_FETCHED> {
	return {type: SETTINGS_FETCHED, payload: {settings}}
}

/**
 * Fetch settings.
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 */
export function fetchSettings(onSuccess: OnSuccessData<Settings>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.settingsApi.fetchSettings().then(settings => {
			dispatch(settingsFetched(settings));
			onSuccess(settings);
		})
	}
}
